import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { useLocation } from "react-router-dom";
import { Result } from 'antd';
import { TextService } from "../../Services/TextService";

const NewUserCreatedWithProvider = () => {
  const GetText = TextService.GetText;

  return <div id="start">
    <Result
      status="success"
      title={GetText("NewUserCreatedWithProvider_Title")}
      subTitle={GetText("NewUserCreatedWithProvider_Description")}
    />
  </div>
};

export default NewUserCreatedWithProvider;